import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getUsageData = async (foiList = [], apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 30000,
        data: {
            "functionid": "getresourceusagelist",
            "formstateidArray": foiList,
            "apiToken": apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'usageDataDictionary': usageDataDictionary }
            if (resp.data.success && resp.data.usageDataDictionary) {
                //usageDataDictionary contains {totalviews: 0, totaledits: 0, totalusersviewed: 0, totalusersedited: 0, editPermission: boolean}
                return resp.data.usageDataDictionary;
            } else {
                console.log("FAILED RESPONSE from getresourceusagelist call")
                return null;
            }
        }
        console.log("NO RESPONSE from getresourceusagelist call");
    }).catch((error) => { console.log(error); });
};

export default getUsageData;